import React from "react";
import PropTypes from "prop-types";

const EngagementErrors = (props) => {
  const { errors } = props;
  const recruiterErrors = errors.recruiter || [];
  const jobErrors = errors.job || [];

  return (
    <div className="alert alert-warning">
      <p>
        <span role="img" aria-label="emoji">
          😳
        </span>{" "}
        Unfortunately you are not currently able to engage on this vacancy.
      </p>
      {recruiterErrors.length > 0 && (
        <p>This is due to limitations on your current plan.</p>
      )}
      <ul>
        {recruiterErrors.concat(jobErrors).map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </div>
  );
};

EngagementErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default EngagementErrors;
